const {
  checkCollectorTerms,
  splitCollectorPoints,
} = require("./product.submodule");

window.addEventListener("DOMContentLoaded", () => {
  checkCollectorTerms();
  splitCollectorPoints();
});
